import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const SearchIcon = (props) => (
  <SvgIcon {...props}>
    <path d="M16.7 15.23a6.777 6.777 0 001.4-4.174A7.02 7.02 0 0011.1 4 7.105 7.105 0 004 11.056a7.105 7.105 0 007.1 7.056 6.667 6.667 0 004.2-1.391l3 2.981a.971.971 0 001.4 0 .957.957 0 000-1.391zm-5.6.8A5.022 5.022 0 016 11.056a5.1 5.1 0 0110.2 0 5.022 5.022 0 01-5.1 4.969z" />
  </SvgIcon>
);
SearchIcon.displayName = 'SearchIcon';
SearchIcon.muiName = 'SvgIcon';

export default SearchIcon;
